import 'moment/locale/sk.js';
import { ITranslationForMts } from './translationInterface';

export const skSkMts: ITranslationForMts = {
    //routes
    route_PrematchHome: 'sk',
    route_TopBetsMobile: 'top',
    route_HomeTopBetsDesktop: 'najtipovanejsie',
    route_HomeLiveDesktop: 'live',
    route_HomeHotBetsDesktop: 'hotbets',
    route_HomeTicketOfDayDesktop: 'tiket-dna',
    route_HomeTopOfferDesktop: 'top-ponuka',
    route_SportsList: 'sporty',
    route_StandardEvents: 'zapasy',
    route_StandardEventDetail: 'zapas',
    route_LiveEvents: 'live-zapasy',
    route_LiveEventDetail: 'live-zapas',
    route_CashOut: 'predaj',
    route_BetDetail: 'moj-tiket',
    route_BetDetailPublic: 'tiket',
    route_LegacyTicketDetailPublic: "tiketl",
    route_BetList: 'moje-tikety',
    route_BetListVG: 'moje-tikety-vh',
    route_BetWinList: 'moje-vyhry',
    route_Search: 'hladanie',
    route_MarketingAction: 'sutaze',
    route_TicketDetail: 'moj-tiket',
    route_TicketDetailVG: 'moj-tiket-vh',
    route_TicketDetailByNumber: 'najdi-tiket',
    route_Calendar: 'kalendar',
    route_Favorites: 'vybrane',
    route_Top5Bets: '',
    route_Top10Bets: '',
    //
    no_categories: 'Žiadne kategórie.',
    today: 'Dnes',
    tomorrow: 'Zajtra',
    yesterday: 'Včera',
    weekend: 'Víkend',
    todayTomorrow: 'Dnes, zajtra ',
    by_date: 'Podľa dátumu',
    by_time: 'Podľa času',
    by_week_day: 'Podľa dní',
    hour: 'hodina',
    three_hours: 'hodiny',
    hours: 'hodín',
    more: 'Viac',
    available_tips: 'Tipy',
    date: 'Uzavretie',
    game: 'Stávková príležitosť',
    deposit: 'Vklad:',
    eventual_winnings: 'Eventuálna výhra:',
    detail: 'Detail',
    other: 'Ďalšie',
    less: 'Menej',
    all: 'Všetko',
    result: 'Výsledok',
    statistics: 'Štatistiky',
    search: 'Hľadaj …',
    no_results: 'Zoznam je prázdny',
    detail_not_found: 'Detail nenájdený',
    back: 'Späť',
    next: "Ďalšie",
    final_rate: 'Výsledný kurz:',
    finished: 'Ukončené',
    match: 'Zápas',
    bet: 'Tip',
    rate: 'Kurz',
    ticket_code: 'Kód tiketu',
    state: 'Stav',
    date_paid: 'Dátum a čas uzavretia tiketu',
    stake: 'Vklad',
    eventual_win: 'Eventuálna výhra',
    ticket_type: 'Druh podaného tiketu',
    bet_type: 'Typ stávky',
    channel: 'Zdroj',
    ticket_detail: 'Detail tiketu',
    prize_paid: 'Výsledná výhra',
    win_paid: 'K výplate',
    ticket_public_link: 'URL k verejnému zobrazeniu tiketu:',
    refresh: 'Aktualizovať',
    download_file: 'Stiahnuť dokument',
    combination: 'kombinácia',
    combinations_0: 'kombinácií',
    combinations_few: 'kombinácie',
    combinations_more: 'kombinácií',
    combination_short: 'komb.',
    event_no_longer_available: 'Udalosť už nie je aktívna.',
    has_to_be_logged_in: 'Pre výber kategórie musíte byť prihlásený.',
    something_went_wrong: 'Chyba na stránke.',
    no_events_for_filter: "Žiadne udalosti nevyhovujú zadanému filtru.",
    no_events_or_leagues_found: "Žiadne udalosti alebo ligy neboli nájdené pre zadaný text.",
    search_searchEventTitle: "Hľadanie",
    flag_new: "nové",

    // --------------------- general
    general_BtnMore: "Viac",
    general_Loading: 'Nahrávam...',
    general_OddsDraw: "Remíza",
    general_EventGameGroupOther: "Ostatné",
    general_EventLiveTag: "LIVE",
    general_CriticalRenderError: 'Chyba na stránke.',
    general_CriticalRenderRefreshBtn: 'Pokračovať',
    general_CriticalRenderHomeBtn: 'Úvodná stránka',
    general_ProgressContentError: 'Chyba pri načítaní, skúste prosím znovu',
    general_ErrorInInitialization: 'Chyba pri inicializácii',
    general_SessionExpired: 'Session Expired',

    // ---------------------- menu
    menu_Top: "Top",
    menu_Prematch: "Stávky",
    menu_Live: "LIVE",
    menu_Cashout: "CASHOUT",
    menu_Search: "Hľadať",
    menu_Time: 'Čas',

    // --------------------- live-menu
    liveMenu_overview: "Prehľad",
    liveMenu_favourites: "Vybrané",
    liveMenu_event: "Udalosť",
    liveMenu_calendar: "Kalendár",

    //------------------- topBets
    topbets_TopBetsTitle: "Najtipovanejšie",
    topbets_HotBetsTitle: "TOP zápasy dňa",
    topbets_NoResults: "Zoznam je prázdny",
    topbets_Top5Title: "TOP 5",
    topbets_Top10Title: "TOP 10",

    //  ---------------------- prematch
    prematch_NoEventsForFilter: "Pre zadaný filter neexistujú žiadne udalosti.",
    prematch_SportListTitle: "PONUKA ŠPORTOV",
    prematch_SportListNoSport: "Pre zadaný časový interval neexistujú žiadne udalosti.",
    prematch_TimeFilterAll: "Všetko",
    prematch_TimeFilterToday: "Dnes",
    prematch_TimeFilterTodayTomorrow: "Dnes,zajtra",
    prematch_TimeFilterWeek: "Týždeň",
    prematch_TabOdds: "Kurzy",
    prematch_TabStats: "Štatistiky",
    prematch_EventNotExists: "Udalosť už nie je v ponuke.",
    prematch_EventListSectionTop: "TOP",
    prematch_EventListSectionOthers: "Ostatné",
    prematch_EventAvailableAsLive: "Zápas už začal, prejdi do LIVE.",

    prematch_MobileExpandMoreVMT: "+ Viac",
    prematch_MobileCollapseMoreVMT: "- Menej",

    // --------------------- live offer
    live_noRates: "Kurzy momentálne nedostupné.",
    live_seeOddsInDetail: "Stavte si na príležitosti v detaile udalosti",
    live_EventHasEnded: "Udalosť už nie je v ponuke.",
    live_OtherEventsBtn: "Iné udalosti",
    live_TabOdds: "Kurzy",
    live_TabMatchTracker: "Animácia",
    live_TabMatchTrackerStats: "Štatistiky",
    live_TabVideo: "Video",
    live_NoEvents: "Aktuálne neprebiehajú žiadne udalosti.",
    live_BaseballCurrentHalfInningStat: "ŠTATISTIKA AKTUÁLNEJ POLSMENY",
    live_AmFootballAttackTeamStat: "ŠTATISTIKA ÚTOČIACEHO MUŽSTVA",
    live_TimelineTitle: "VÝVOJ ZÁPASU",
    live_TimelineDesktopTitle: "Udalosti v zápase",
    live_ScoreMainScoreTitle: "Stav",
    live_OddBelowName: "Pod",
    live_Favorites: "Vybrané",
    live_NoFavorites: "Žiadne vybrané udalosti.",

    live_WarrantyInfo: "Uvedené časové a štatistické údaje sú len orientačné. Spoločnosť SYNOT TIP a.s., neručí za správnosť a aktuálnosť zobrazovaných informácii (napr. aktuálne skóre). Na základe týchto údajov nie je možné uznať prípadné reklamácie.",

    // ------------------------------ desktop live
    desktopLive_OpenEvents: "Teraz live",
    desktopLive_FavoriteEvents: "Vybrané",
    desktopLive_NoFavoriteEvents: "Nie je vybraný žiadny zápas. Zápasy vyberiete kliknutím na hviezdičku v ľavom stĺpci alebo na úvodnej stránke",

    //--------------------- coupon

    coupon_commonError: "Stávka obsahuje chybné tipy.",

    coupon_LoginForSend: "Prihláste sa pre podanie",
    coupon_UpdatingSystem: "aktualizujem ...",
    coupon_CouponGeneralError: "Došlo k chybe pri spracovaní",
    coupon_CouponExpectedNotSystemError: "Interná chyba pri spracovaní,vymažte tiket a pridajte tipy znovu",
    coupon_CopyGeneralError: "Došlo k chybe pri príprave kópie tiketu",
    coupon_StakeInputError: "Hodnota pre vklad nie je správne zadaná",
    coupon_TicketListCombination: "KOMBINÁCIA",
    coupon_TicketListStake: "VKLAD",
    coupon_TicketListRate: "KURZ",
    coupon_TicketListPotentialWin: "EVENTUÁLNA VÝHRA",
    coupon_SystemSwitchLabel: "KOMBI",

    coupon_HeaderSystemCouponSetting: "Nastavenie systémového tiketu",
    coupon_StakeTypeCoupon: "KUPÓN",
    coupon_StakeTypeSystem: "SYSTÉM",

    coupon_SummaryPricePotential: "Eventuálna výhra",
    coupon_Stake: "Vklad",
    coupon_MaxStake: "max.",
    coupon_TotalRate: "Výsledný kurz",
    coupon_StakeForOneTicketInSystem: "Vklad na stávku",
    coupon_AverageRate: "Priemerný kurz",

    coupon_SentSuccessMessage: "Vaša stávka bola prijatá. Ďakujeme.",
    coupon_SentRejectMessage: "Podanie tiketu bolo zamietnuté",
    coupon_CopyTicket: "Rovnaký tiket",
    coupon_NewTicket: "Nový tiket",

    coupon_evaluateBtn: "Prepočítať",
    coupon_acceptRateChangeBtn: "Akceptovať",
    coupon_sendToPay: "Podať",

    coupon_liveAcceptHigerRate: "Prijať zvýšenie kurzov",
    coupon_liveAcceptAllRates: "Prijať akékoľvek kurzy",
    coupon_liveHint_Question: "Doporučená výška vkladu na Vašu stávku je {value}. Súhlasíte?",
    coupon_liveHint_Yes: "Áno",
    coupon_liveHint_No: "Nie",

    coupon_TypePrematch: "Štandard",
    coupon_TypeLive: "Live",

    coupon_OddTitle: "Tip",

    coupon_AddPublicLinkToChat: "Vložit odkaz do chatu",

    // -------------------- ticket
    ticket_TicketTabLabel: "Tiket",
    ticket_BettingTicket: "Stávkový tiket",
    ticket_SelectionCount: "Počet tipov",
    ticket_StakeTypeAll: "KUPÓN",
    ticket_StakeTypeUnit: "KOMBI",
    ticket_StakeTypeTotal: "SYSTÉM",
    ticket_OddTitle: "Tip",
    ticket_BankerTitle: "Tutovka",
    ticket_HasErrors: "Tiket obsahuje chyby",
    ticket_TicketTypeSimple: "Jednoduchý", //--Simple
    ticket_TicketTypeSystem: "Kombi",  //--System
    ticket_TicketTypeVGSplit: "Rozdelený stĺpec",
    ticket_TicketTypeVGCombi: "Kombi",
    ticket_EvalTypeLost: "Nevýherný",
    ticket_EvalTypeWin: "Výherný",
    ticket_EvalTypeCancelledWithMP: "Zrušený",
    ticket_EvalTypeCancelled: "Zrušený",
    ticket_EvalTypeCashout: "Predaný",
    ticket_NoTips: "Váš tiket neobsahuje žiadne tipy.",
    ticket_Ticket: 'Tiket',
    ticket_TicketStateSettled: "Vyhodnotený",
    ticket_TicketStateStorno: "Stornovaný",
    ticket_TicketStateStornoBySystem: "Stornovaný",
    ticket_TicketStateStornoByMts: "Neprijatý",
    ticket_TicketStateCommonAccepting: "Spracováva sa",
    ticket_TicketStateCommonAccepted: "Prijatý",
    ticket_Login: "Prihláste sa pre zobrazenie tiketu.",
    ticket_Calculations: "Prehľad kombinácií",
    ticket_NotFound: "Tiket nenájdený",
    ticket_TicketOfNumberNotFound: "Tiket {number} nebol nájdený",
    ticket_Group: "Sk.",
    ticket_CashoutTab: 'PREDAJ',
    ticket_PrepareTicket: "Pripraviť tiket",
    ticket_SelectionResult: "Výsledok",

    ticket_ReuseOddsTicketBtn: "Pridať na nový tiket",
    ticket_ReuseOddsGeneralError: "Nepodarilo sa pridať tipy na tiket, skúste to znova.",
    ticket_ReuseOddsNotAllAddedError: "Niektoré tipy nebolo možné pridať na tiket, pretože už nie sú v ponuke.",

    //my-tickets
    myTickets_NoTicket: 'Žiadne tikety',
    myTickets_Login: "Prihláste sa pre zobrazenie tiketov.",
    myTickets_ColumnPotentialPrice: 'Ev.výhra',
    myTickets_TypeSports: "Kurzové stávky",
    myTickets_TypeVirtualGames: "Virtuálne hry",

    //Mobile App advert
    mobileAppAdvert_title: "Mobile Sports apps",

    // ---------------------- bet detail
    bet_TicketIdTitle: "Kód tiketu",
    bet_TicketStateTitle: "Stav",
    bet_TicketReasonTitle: "Dôvod",
    bet_TicketDatePaid: "Dátum a čas uzavretia tiketu",
    bet_System: "Systém",
    bet_Stake: "Vklad",
    bet_TotalRate: "Výsledný kurz",
    bet_PotentialPrice: "Eventuálna výhra",
    bet_FinalWin: "Výsledná výhra",
    bet_ToPayout: "K výplate",
    bet_TicketType: "Druh podaného tiketu",
    bet_BetType: "Typ stávky",
    bet_CanBeCancelledUntil: "Tiket je možné stornovať do",
    bet_Channel: "Zdroj",
    bet_Match: "Zápas",
    bet_Tip: "Tip",
    bet_TipWinTip: "Tip / Výherný tip",
    bet_TipTicketDetail: "Tip",
    bet_Sum: "Suma", // kde sa používa?
    bet_PossibleWinFrom: "Možná výhra od",
    bet_PossibleWinTo: "Možná výhra do",
    bet_Errors: 'Chyby',
    bet_HandlingFee: "Man. poplatok",
    bet_ProductFee: "Poplatok za produkt",
    bet_ProductName: "Produkt",
    bet_OddsRateAdvantage: "Zvýhodnený kurz",
    bet_RateAdvantageFactor: "Kurzové zvýhodnenie",
    bet_Header: "Detail tiketu",
    bet_SuccessfulCashout: "Tiket bol predaný",
    bet_ErrorDuringCashout: "Nepodarilo sa predať tiket",
    bet_ReallyCashoutBetOfValue: "Naozaj chcete predčasne vyplatiť tiket za {value} ?",
    bet_FreeTicketSection: "Voľný tiket",

    bet_PublicLink: "URL k verejnému zobrazeniu tiketu",
    bet_TransferToCredit: "Prevod na kredit",
    bet_TransferToBank: "Prevod do banky",

    bet_CopyConfirmYes: "Áno",
    bet_CopyConfirmNo: "Nie",
    bet_CopyConfirmQuestion: "Pre podanie za nižší vklad je potrebné prepísať aktuálny tiket. Súhlasíte?",
    bet_CopyConfirmTitle: "STÁVKOVÝ TIKET",

    bet_AgreeWithLowerAmount: "Súhlasite so zníženou čiastkou?",
    bet_Cashout: "Predaj",
    bet_ErrorInTicketListLoad: "Chyba pri nahraní zoznamu tiketov",

    bet_CancelUntil: 'Tiket je možné stornovať do',
    bet_CancelSuccess: 'Tiket bol stornovaný.',
    bet_CancelError_AlreadyCancelled: 'Tiket už bol stornovaný.',
    bet_CancelError_PeriodOver: 'Uplynul čas pre storno tiketu.',
    bet_CancelError_NotForThisPlayer: 'Tiket je od iného hráča.',
    bet_CancelError_GeneralError: 'Chyba pri storne tiketu.',
    bet_CancelBetBtnCancelTitle: "Storno",

    coupon_CashoutAcceptHigerRate: "Prijať zvýšenie čiastky",
    coupon_CashoutAcceptAllRates: "Prijať akúkoľvek čiastku",
    coupon_cashoutButton: "Predaj za {value}",



    // ---------------- cashoutList
    cashoutList_ColumnTime: "čas",
    cashoutList_ColumnStake: "vklad",
    cashoutList_ColumnPotentialPrice: "Výhra",
    cashoutList_ColumnSell: "Predaj",
    cashoutList_NoTickets: "Zatiaľ nemáte tikety na predaj.",
    cashoutList_Login: "Prihláste sa pre zobrazenie tiketov na predaj.",
    cashoutList_LoadAgain: "Znovu",

    //--------------------- betList
    betList_TicketNumber: 'Kód tiketu',
    betList_ColumnTime: "Dátum",
    betList_ColumnStake: "Vklad",
    betList_ColumnPotentialPrice: "Ev.výhra",
    betList_ColumnPricePotentialPrice: "Ev.výhra/výhra",
    betList_ColumnStatus: "Stav",
    betList_ColumnDetail: "Detail",

    //--------------------- ticketList
    ticketList_TimeFilter_None: "-všetko-",
    ticketList_TimeFilter_Day: "Deň",
    ticketList_TimeFilter_ThreeDays: "Tri dni",
    ticketList_TimeFilter_Week: "Týždeň",
    ticketList_TimeFilter_TwoWeeks: "2 týždne",
    ticketList_TimeFilter_Month: "Mesiac",

    ticketList_StateFilter_None: "-všetko-",
    ticketList_StateFilter_Accepted: "Prijatý",
    ticketList_StateFilter_Win: "Výherný",
    ticketList_StateFilter_Loss: "Nevýherný",
    ticketList_StateFilter_CancelWithHandlingFee: "Zrušený",
    ticketList_StateFilter_Cashout: "Predaný",
    ticketList_StateFilter_Storno: "Stornovaný",//myslí sa tym technicke storno?

    ticketList_OfferTypeFilter_None: "-všetko-",
    ticketList_OfferTypeFilter_Prematch: "Štandard",
    ticketList_OfferTypeFilter_Live: "Live",

    ticketList_Title: "Prehľad tiketov",
    ticketList_TimeFilterTitle: "Časové obdobie",
    ticketList_StateFilterTitle: "Stav",
    ticketList_OfferTypeFilterTitle: "Typ stávky",
    ticketList_FilterSubmit: "Zobraziť",

    // ------------- ticket detail
    bet_FinalScoreInfo: "Finálne skóre zobrazené vo výsledkoch zahŕňa aj skóre v prípade predĺženia alebo penaltového rozstrelu.",

    //-------------------- search
    search_FillSomethingInfo: "Zadajte názov udalosti alebo ligy",
    search_LastSearch: "Posledné hľadanie:",
    search_ResultEvents: "Zápasy",
    search_ResultLeagues: "Ligy",
    search_NothingFound: "Nenašli sme takýto zápas alebo ligu.",
    search_InProgress: "Hľadám ...",

    // ----------------- offline
    offline_InfoText: "Prerušenie pripojenia k internetu alebo na server",
    offline_TryReconnect: "Skúsiť pripojiť znovu",

    // ------------ recommended
    recommended_title: "Odporúčame",

    // ----------- mobile QR code
    mobileAppLinkAdvert_Header: "Mobilná aplikácia",

    // ----------- marketing action
    marketingAction_NoAction: "Akcia nebola nájdená",
    marketingAction_Next: "Ďalší",
    marketingAction_Less: "Menej",

    //--------- live stream / matchtracker
    liveStream_Opening: "Otváram ...",
    liveStream_ErrorOpening: "Nepodarilo sa otvoriť video.",
    liveStream_NeedToLogin: "Pre zobrazenie live prenosu musíte byť prihlásený.",
    liveStream_NeedLiveStreamAccess: "Pre zobrazenie prenosu musíte mať dokončenú registráciu.",
    liveStream_NotPlayedNow: "Live prenos zatiaľ nie je k dispozícii. Začiatok je %1.",
    liveStream_NotAvailableFormat: "Nepodarilo sa otvoriť video. Začiatok je %1.",
    liveStream_TryAgain: "Skúsiť znovu",
    liveStream_NoVideoForThisPart: "Nepodarilo sa otvoriť video.",
    livestream_Login: "Login",

    // -------- live notifications
    liveNotification_ErrorOnUpdate: "Nepodarilo sa aktualizovať nastavenie",
    liveNotification_Header: "Live upozornenia k udalosti",
    liveNotification_AllowRequestText: 'Povoliť notifikácie v nastaveniach vášho zariadenia.',
    liveNotification_AllowRequestButton: 'Povoliť',
    liveNotification_NeedAllowInBrowserPermissions: " Pre prijímanie správ o zápase musíte povoliť vo svojom prehľadávači notifikácie.",

    //right column
    rightColumn_MyBetsToday: "MOJE DNEŠNÉ STÁVKY",
    rightColumn_NoBetsToday: "Dnes ešte nemáte podaný tiket",
    rightColumn_LoadAgain: "Znovu",

    //find ticket by number
    findTicketByNumber_title: "KONTROLA TIKETU",
    findTicketByNumber_InfoText: "Zadajte tu prosím číslo stávky nad čiarovým kódom:",
    findTicketByNumber_buttonSend: "Kontrola",
    findTicketByNumber_Placeholder: "Číslo stávky",

    //chat
    chat_WriteMessagePlaceholder: "vaša správa...",  //chat.yourMessage
    chat_SendMessage: "Odoslať", //chat.sendMessage
    chat_Sending: "Odosielam ...", //chat.sendingText
    chat_LoginToSendMessage: "Pre odoslanie správy sa musíte prihlásiť...",  //chat.loginToSendMessageInfo
    chat_LoadingMessages: "nahrávam správy",
    chat_ErrorLoadingMessagesAgainBtn: "znovu",  //chat.btnErrorLoadingMessagesAgain
    chat_ErrorLoadingMessage: "nepodarilo sa nahrať správy",  //chat.errorLoadingMessages
    chat_PrivateReply: "Súkromná správa",//chat.privateReply     // cjuba "Uživatelé mi můžou psát privátně",  //chat.acceptAllUsers
    chat_PublicReply: "Verejná odpoveď",  //chat.publicReply
    chat_AcceptAllUsers: "Užívatelia mi môžu písať súkromne",  //chat.acceptAllUsers
    chat_BlockAllUsers: "Nikto mi nemôže písať súkromne",  //chat.blockAllUsers
    chat_BlockedUser: "Užívateľ mi nemôže napísať súkromnú správu", //chat.blockedUser
    chat_NonblockedUser: "Užívateľ mi môže napísať súkromnú správu",
    chat_NeedNickname: "Nemáte zadanú prezývku. Chat Vám bude sprístupnený po zadaní prezývky v profile hráča.",
    chat_AnswerForTitle: "Odpoveď pre",
    chat_ChatSendMessage_Success: "Správa bola uložená",  //chat.sendMsgOk
    chat_ChatSendMessage_NonExistentReply: "Správa, na ktorú odpovedáte, neexistuje",  //chat.sendMsgNoSourceMsg
    chat_ChatSendMessage_PrivateBlocked: "Užívateľ si zablokoval súkromné správy",  //chat.sendMsgBlockedPrivate
    chat_ChatSendMessage_TimeConstraintFailed: "Je potrebné počkať %1 sekúnd od poslednej správy", //chat.sendMsgProtection
    chat_ChatSendMessage_UserBanned: "Užívateľ má zakázané posielať správy",  //chat.sendMsgBanned
    chat_ChatSendMessage_UserNotLogged: "Nie ste prihlásený",  //chat.sendMsgNotLogged
    chat_ChatSendMessage_Fail: "Chyba pri odosielaní správy",  //chat.sendMsgError

    //saved ticket  // netreba prekladat do SK a CZ, pouziva sa iba v LV
    savedTicket_header: 'Notice',
    savedTicket_thanks: 'Your bet has been saved. Thank you.',
    savedTicket_p1: 'You can place your bet at any of the over-the-counter betting centres using the number',
    savedTicket_p2: 'Bets cannot be placed once the taking of bets for the given prediction has closed, or after',
    savedTicket_warning: 'Place your bets as soon as you can! The odds in the offer frequently change and bets can be rejected because of a change in the odds.',
    savedTicket_identicalBet: 'Identical bet',

    //calendar
    calendar_startTime: 'začiatok',
    calendar_event: 'udalosť',
    calendar_category: 'kategória',

    //upcoming events
    upcomingEvents_label: 'dnes nasleduje',

    //favorites
    my_favorites: "Moje",

    //live Favorites
    liveFavorites_showMoreDetails: "Zobraziť ďalšiu ponuku",
    liveFavorites_hideMoreDetails: 'Skryť ďalšiu ponuku',

    //OTB
    otb_Switch: 'Rýchla stávka',
    otb_InfoText: 'Aktiváciou rýchlej stávky podáš sólo stávku okamžite kliknutím na kurz vybranej stávkovej príležitosti.',
    otb_InfoWarning: "Pre aktiváciu Rýchlej stávky, prosím, potvrďte nastavenia.",
    otb_SettingHeader: "Nastavenia Rýchlej stávky:",
    otb_FirstPage_Cancel: "Zrušiť",
    otb_FirstPage_Confirm: "Potvrdiť",
    otb_TurnOffOTB: "Vypnúť rýchle stávky",
    otb_CancelBetslip: "Zrušiť tiket",
    otb_Sending: "Podávam",

    // rate filter
    rateFilter_Title: "Kurz",
    rateFilter_From: "Od",
    rateFilter_To: "Do"
};
